import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Plus, Users, Clock, Calendar, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button, CardStats } from '@components/ui';
import { getPuantajByTarih, getPuantajStats } from '@mocks/puantaj';
import PuantajTablosu from '../Puantaj/PuantajTablosu';
import PuantajModal from '../Puantaj/PuantajModal';

/**
 * PersonelPuantaj — Puantaj sekmesi wrapper
 * Personel sayfasının "Puantaj" sekmesinde gösterilir.
 */
export default function PersonelPuantaj() {
    const { selectedConstruction, showAllConstructions } = useSelector((state) => state.construction);
    const insaatId = showAllConstructions ? null : selectedConstruction?.id;

    const [selectedTarih, setSelectedTarih] = useState(new Date().toISOString().split('T')[0]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedKayit, setSelectedKayit] = useState(null);

    const kayitlar = getPuantajByTarih(selectedTarih, insaatId);
    const stats = getPuantajStats(insaatId, selectedTarih);

    const formatTarih = (tarihStr) => {
        const tarih = new Date(tarihStr);
        return tarih.toLocaleDateString('tr-TR', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const navigateTarih = (direction) => {
        const current = new Date(selectedTarih);
        current.setDate(current.getDate() + direction);
        setSelectedTarih(current.toISOString().split('T')[0]);
    };

    const handleAdd = () => { setSelectedKayit(null); setModalOpen(true); };
    const handleEdit = (kayit) => { setSelectedKayit(kayit); setModalOpen(true); };

    const handleSubmit = (data) => {
        console.log('Puantaj kaydı:', data);
        toast.success(selectedKayit ? 'Kayıt güncellendi' : 'Puantaj kaydedildi');
        setModalOpen(false);
        setSelectedKayit(null);
    };

    return (
        <>
            {/* Tarih Seçici */}
            <div className="flex items-center justify-center gap-4 bg-bg-secondary rounded-xl p-4 border border-border-light">
                <Button variant="ghost" size="sm" onClick={() => navigateTarih(-1)}>
                    <ChevronLeft size={20} />
                </Button>
                <div className="flex items-center gap-3">
                    <Calendar size={20} className="text-text-muted" />
                    <input
                        type="date"
                        value={selectedTarih}
                        onChange={(e) => setSelectedTarih(e.target.value)}
                        className="bg-transparent border-none text-lg font-semibold text-text-primary focus:outline-none cursor-pointer"
                    />
                </div>
                <Button variant="ghost" size="sm" onClick={() => navigateTarih(1)}>
                    <ChevronRight size={20} />
                </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                <CardStats title="Toplam Personel" value={stats.toplamPersonel} icon={Users} color="primary" size="sm" />
                <CardStats title="Çalışan" value={stats.calisanSayisi} icon={Users} color="success" size="sm" />
                <CardStats title="Toplam Saat" value={`${stats.toplamSaat.toFixed(1)} saat`} icon={Clock} color="secondary" size="sm" />
                <CardStats title="Fazla Mesai" value={`+${stats.fazlaMesaiSaat.toFixed(1)} saat`} icon={Clock} color="warning" size="sm" />
                <CardStats title="İzinli/Raporlu" value={stats.izinliSayisi} icon={Users} color="info" size="sm" />
            </div>

            {/* Ekle Butonu */}
            <div className="flex justify-end">
                <Button variant="primary" icon={<Plus size={18} />} onClick={handleAdd}>
                    Puantaj Ekle
                </Button>
            </div>

            {/* Tablo */}
            {kayitlar.length > 0 ? (
                <PuantajTablosu data={kayitlar} onEdit={handleEdit} />
            ) : (
                <div className="bg-bg-secondary rounded-xl p-12 text-center border border-border-light">
                    <Users size={48} className="mx-auto text-text-muted mb-4" />
                    <h2 className="text-xl font-semibold text-text-primary mb-2">Bu tarihte kayıt yok</h2>
                    <p className="text-text-secondary mb-4">{formatTarih(selectedTarih)} için puantaj kaydı bulunmuyor.</p>
                    <Button variant="primary" icon={<Plus size={18} />} onClick={handleAdd}>Puantaj Ekle</Button>
                </div>
            )}

            {/* Modal */}
            <PuantajModal
                isOpen={modalOpen}
                onClose={() => { setModalOpen(false); setSelectedKayit(null); }}
                onSubmit={handleSubmit}
                kayit={selectedKayit}
                tarih={selectedTarih}
            />
        </>
    );
}
